module.exports = __webpack_public_path__ + "img/client2.763899ec.png";